// ============================================================
// DESTINO: frontend/src/App.js
// Mudanca: adicionado import JoinPage e rota /join/:code
// ============================================================
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Nav from "@/components/pinwin/Nav";
import Hero from "@/components/pinwin/Hero";
import TwoSides from "@/components/pinwin/TwoSides";
import HowItWorks from "@/components/pinwin/HowItWorks";
import FourTabs from "@/components/pinwin/FourTabs";
import Resenha from "@/components/pinwin/Resenha";
import Sports from "@/components/pinwin/Sports";
import Manifesto from "@/components/pinwin/Manifesto";
import Waitlist from "@/components/pinwin/Waitlist";
import Footer from "@/components/pinwin/Footer";
import ClaimPage from "@/components/pinwin/ClaimPage";
import JoinPage from "@/components/pinwin/JoinPage";
import ProfilePage from "@/components/pinwin/ProfilePage";
import Terms from "@/components/pinwin/Terms";
import Privacy from "@/components/pinwin/Privacy";
import LoginPage from "@/components/pinwin/LoginPage";
import { LanguageProvider } from "@/lib/i18n";

function LandingPage() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    let rafId;
    function raf(time) {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    }
    rafId = requestAnimationFrame(raf);
    window.__lenis = lenis;
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App bg-[#0A0A0A] text-white selection:bg-[#E6FF00]" data-testid="landing-page">
      <Nav />
      <main>
        <Hero />
        <TwoSides />
        <HowItWorks />
        <FourTabs />
        <Resenha />
        <Sports />
        <Manifesto />
        <Waitlist />
      </main>
      <Footer />
      <Toaster position="bottom-right" theme="dark" />
    </div>
  );
}

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/claim/:token" element={<ClaimPage />} />
          <Route path="/join/:code" element={<JoinPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/:handle" element={<ProfilePage />} />
          <Route path="*" element={<LandingPage />} />
        </Routes>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
